import script from "./InspectorsList.vue?vue&type=script&lang=ts&setup=true"
export * from "./InspectorsList.vue?vue&type=script&lang=ts&setup=true"

import "./InspectorsList.vue?vue&type=style&index=0&id=1f307e13&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f307e13"]])

export default __exports__